import { Users, ShieldCheck, BadgeAlert, Flag } from "lucide-react";

const tips = [
  { icon: Users, title: "Meet in public places", desc: "Always meet sellers in busy, well-lit areas." },
  { icon: ShieldCheck, title: "Verify the product", desc: "Inspect items thoroughly before you pay." },
  { icon: BadgeAlert, title: "Avoid advance payments", desc: "Never wire money before seeing the product." },
  { icon: Flag, title: "Report suspicious users", desc: "Help us keep the community safe — flag misuse." },
];

export function SafetyTips() {
  return (
    <section className="border-y border-border bg-secondary/60">
      <div className="mx-auto max-w-7xl px-4 py-12 md:py-16">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl font-bold text-foreground md:text-3xl">Stay safe while you buy & sell</h2>
          <p className="mt-2 text-sm text-muted-foreground">A few simple steps protect every transaction.</p>
        </div>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {tips.map(({ icon: Icon, title, desc }) => (
            <div key={title} className="rounded-2xl border border-border bg-card p-5">
              <span className="grid h-11 w-11 place-items-center rounded-xl bg-accent-soft text-accent">
                <Icon className="h-5 w-5" />
              </span>
              <h3 className="mt-4 font-heading text-base font-semibold text-foreground">{title}</h3>
              <p className="mt-1 text-sm text-muted-foreground">{desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}